/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconListNumbers = createReactComponent("outline", "list-numbers", "IconListNumbers", [["path", { "d": "M11 6h9", "key": "svg-0" }], ["path", { "d": "M11 12h9", "key": "svg-1" }], ["path", { "d": "M12 18h8", "key": "svg-2" }], ["path", { "d": "M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4", "key": "svg-3" }], ["path", { "d": "M6 10v-6l-2 2", "key": "svg-4" }]]);

export { IconListNumbers as default };
//# sourceMappingURL=IconListNumbers.mjs.map
